var _path, _circle, _rect, _path2, _circle2, _circle3, _circle4, _rect2, _path3, _circle5, _circle6, _circle7, _rect3, _path4, _circle8, _circle9, _circle0, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDataDeletion(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.21 54.74a3.64 3.64 0 011.44.31V18.66h-2.89v36.39a3.66 3.66 0 011.45-.31zM5.11 56.91h30.88v2.89H5.11z",
    fill: "#1b3e6f"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27.21,
    cy: 58.35,
    r: 3.61,
    fill: "#00a3f5"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5.11,
    y: 38.51,
    width: 50.2,
    height: 14.79,
    rx: 2.89,
    fill: "#cfd3d4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6 42.29a.73.73 0 01-.73.73h-13a.73.73 0 010-1.45h13a.73.73 0 01.73.72zM26.6 45.9a.73.73 0 01-.73.73h-13a.73.73 0 010-1.45h13a.73.73 0 01.73.72zM26.6 49.51a.73.73 0 01-.73.73h-13a.73.73 0 01-.72-.73.72.72 0 01.72-.72h13a.73.73 0 01.73.72z",
    fill: "#b3b3b3"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 35.98,
    cy: 45.58,
    r: 2.17,
    fill: "#fff"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 41.76,
    cy: 45.58,
    r: 2.17,
    fill: "#5dcbfc"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 47.53,
    cy: 45.58,
    r: 2.17,
    fill: "#5dcbfc"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5.11,
    y: 22.1,
    width: 50.2,
    height: 14.79,
    rx: 2.89,
    fill: "#cfd3d4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6 25.89a.73.73 0 01-.73.72h-13a.72.72 0 010-1.44h13a.73.73 0 01.73.72zM26.6 29.5a.73.73 0 01-.73.72h-13a.72.72 0 01-.72-.72.73.73 0 01.72-.73h13a.73.73 0 01.73.73zM26.6 33.11a.73.73 0 01-.73.72h-13a.73.73 0 010-1.45h13a.73.73 0 01.73.73z",
    fill: "#b3b3b3"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 35.98,
    cy: 29.17,
    r: 2.17,
    fill: "#fff"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 41.76,
    cy: 29.17,
    r: 2.17,
    fill: "#fff"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 47.53,
    cy: 29.17,
    r: 2.17,
    fill: "#fff"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 5.11,
    y: 5.69,
    width: 50.2,
    height: 14.79,
    rx: 2.89,
    fill: "#cfd3d4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6 9.48a.73.73 0 01-.73.72h-13a.72.72 0 110-1.44h13a.73.73 0 01.73.72zM26.6 13.09a.73.73 0 01-.73.72h-13a.72.72 0 110-1.44h13a.73.73 0 01.73.72zM26.6 16.7a.73.73 0 01-.73.72h-13a.72.72 0 010-1.44h13a.73.73 0 01.73.72z",
    fill: "#b3b3b3"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 35.98,
    cy: 12.76,
    r: 2.17,
    fill: "#fff"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 41.76,
    cy: 12.76,
    r: 2.17,
    fill: "#fff"
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: 47.53,
    cy: 12.76,
    r: 2.17,
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M58 60.78a1.46 1.46 0 01-1.46 1.46H39a1.47 1.47 0 01-1.46-1.46l-1.47-21.47h23.42z",
    fill: "#5dcbfc"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M53.63 33.45v1.47h-2v-1.47a.49.49 0 00-.49-.49h-6.78a.49.49 0 00-.49.49v1.47h-1.95v-1.47A2.44 2.44 0 0144.36 31h6.83a2.44 2.44 0 012.44 2.45z",
    fill: "#00a3f5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M61 36.38v1.95a1 1 0 01-1 1H35.09a1 1 0 01-1-1v-1.95a1.46 1.46 0 011.47-1.46h23.93A1.46 1.46 0 0161 36.38zM40.46 42.72h1.95v15.61h-1.95zM44.85 42.72h1.95v15.61h-1.95zM49.24 42.72h1.95v15.61h-1.95zM53.63 42.72h1.95v15.61h-1.95z",
    fill: "#00a3f5"
  })));
}
export default "data:image/svg+xml;base64,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";
export { SvgDataDeletion as ReactComponent };